import { render, staticRenderFns } from "./CodeEditorComponent.vue?vue&type=template&id=1cde8184&scoped=true"
import script from "./CodeEditorComponent.vue?vue&type=script&lang=js"
export * from "./CodeEditorComponent.vue?vue&type=script&lang=js"
import style0 from "./CodeEditorComponent.vue?vue&type=style&index=0&id=1cde8184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde8184",
  null
  
)

export default component.exports